<template>
  <article
    :class="[
      unreaded ? 'conversation-box conversation-box--new' : 'conversation-box'
    ]"
  >
    <!-- <div :class="[people ? 'profile-thumbnail profile-thumbnail--multiple' : 'profile-thumbnail']">
      <div v-if="!people" class="profile-thumbnail__photo">
        <img src="@/assets/images/profile-photo.jpg" alt="">
      </div>
      <div v-if="people" class="profile-thumbnail__photo">
        <img src="@/assets/images/profile-photo.jpg" alt="">
      </div>
      <div v-if="people" class="profile-thumbnail__photo">
        <img src="@/assets/images/profile-photo.jpg" alt="">
      </div>
      <Badge v-if="unreaded">{{ unreaded }}</Badge>
    </div>
    / profile-thumbnail -->

    <ProfilePhoto :images="images" :unreaded="unreaded"></ProfilePhoto>

    <div class="conversation-box__content">
      <h2 v-if="!isMultiple" class="conversation-box__title">{{ name }}</h2>
      <h2 v-else class="conversation-box__title">{{ peopleString }}</h2>
      <p class="conversation-box__last"><slot></slot></p>
    </div>
    <!-- / message-box__content -->

    <Badge v-if="unreaded" :isAlt="true" :isNew="true">new</Badge>
  </article>
</template>

<script>
import Badge from "@/components/Badge.vue";
import ProfilePhoto from "@/components/ProfilePhoto.vue";

export default {
  name: "ConversationBox",
  components: {
    Badge,
    ProfilePhoto
  },
  props: {
    isMultiple: Boolean,
    unreaded: Number,
    name: String,
    people: Array,
    images: Array
  },
  computed: {
    peopleString: function() {
      const people = this.people;
      let peopleString = "";

      if (people) {
        people.forEach((element, index) => {
          if (index < 3) {
            peopleString += `${element}, `;
          } else if (index == 3) {
            peopleString += `${element}... `;
          }
        });

        peopleString += `+${people.length - 4}`;
      }
      return peopleString;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.conversation-box {
  border-top: 1px solid rgba($txt-color, 0.03);
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding: 5px 10px;
  flex-wrap: wrap;
  display: flex;
  width: 100%;

  @media #{$bigger-mobile} {
    padding: 8px 12px;
  }

  &:after {
    content: "";
    background: url("../assets/images/arrow.svg") no-repeat;
    background-position: right center;
    transform: translateY(-50%);
    background-size: contain;
    position: absolute;
    opacity: 0.1;
    height: 10px;
    right: 20px;
    width: 10px;
    top: 50%;
  }

  &:last-of-type {
    border-bottom: 1px solid rgba($txt-color, 0.03);
  }

  &__content {
    width: calc(100% - 120px);
  }

  &__title {
    text-overflow: ellipsis;
    letter-spacing: 0.4px;
    white-space: nowrap;
    margin-bottom: 6px;
    font-weight: 600;
    overflow: hidden;
    font-size: 10px;

    @media #{$bigger-mobile} {
      font-size: 13px;
    }
  }

  &__last {
    color: rgba($txt-color, 0.4);
    text-overflow: ellipsis;
    letter-spacing: 0.36px;
    white-space: nowrap;
    position: relative;
    overflow: hidden;
    font-size: 9px;

    @media #{$bigger-mobile} {
      font-size: 10px;
    }

    &::first-letter {
      text-transform: uppercase;
    }
  }

  .profile-thumbnail {
    margin-right: 15px;
  }

  .badge {
    &--new {
      transform: translateY(-50%);
      position: absolute;
      bottom: auto;
      right: 20px;
      top: 50%;
    }
  }

  &--new {
    background-color: $color-secondary;

    &:after {
      display: none;
    }

    .conversation-box__last {
      padding-left: 11px;

      &:before {
        content: "";
        background-color: $color-primary;
        transform: translateY(-50%);
        border-radius: 9999px;
        position: absolute;
        height: 4px;
        width: 4px;
        top: 50%;
        left: 0;
      }
    }
  }
}
</style>
